export default __webpack_public_path__ + "static/media/thotakura-venkata-ramana.8dc03ddb.png";